
















import Setup from '../../setup';
import {Component, Vue} from 'vue-property-decorator';
import TournamentPlayers from '../../components/tournament/TournamentPlayers.vue';
import TournamentReports from '../../components/tournament/TournamentReports.vue';
import TournamentRequests from '../../components/tournament/TournamentRequests.vue';
import {generateLangSubscriptions, observeProp, observeRouteParam} from '@/components/observe';
import {of} from 'rxjs';
import {Route} from 'vue-router';

@Component<TournamentView>({
  components: {
    TournamentPlayers,
    TournamentReports,
    TournamentRequests,
  },
  subscriptions() {
    const $route$ = observeProp<Route>(this, '$route');
    const lang$ = observeRouteParam<string>($route$, 'lang');
    return Object.assign(generateLangSubscriptions(lang$), {
      isGuest: of(!(parseInt(Setup.userId(), 10) > 0)),
      tournament: of(Setup.tournamentId()),
      heroesVersion: of(Setup.heroesVersion()),
      forumThreadId: of(Setup.forumThreadId()),
      isOrganizer: of(Setup.isOrganizer()),
      canChangeRequests: of(Setup.canChangeRequests()),
    });
  },
})
export default class TournamentView extends Vue {
}
